import React, { FunctionComponent } from 'react'
import { FormattedMessage } from 'react-intl'

import { useTheme } from 'styled-components/native'

import { CARELON_REGIONAL_NETWORK_MESSAGES } from '@lyrahealth-inc/shared-app-logic/src/features/searchForCare/messages'

import { InPersonStroke } from '../../atoms/icons/InPersonStroke'
import { CareOptionCard } from '../../templates/careOptionCard/CareOptionCard'
import { tID } from '../../utils/utils'

export interface CareNavigatorCarelonDirectoryOptionCardProps {
  onPress: (() => void) | undefined
  isRegionalNetworkCopyEnabled: boolean
}

export const CareNavigatorCarelonDirectoryOptionCard: FunctionComponent<
  CareNavigatorCarelonDirectoryOptionCardProps
> = ({ onPress, isRegionalNetworkCopyEnabled }) => {
  const { colors } = useTheme()

  const optionHeader = isRegionalNetworkCopyEnabled ? (
    <FormattedMessage {...CARELON_REGIONAL_NETWORK_MESSAGES.header} />
  ) : (
    <FormattedMessage
      defaultMessage='Carelon Behavioral Health'
      description='Title for Carelon Behavioral Health provider directory link on Care Navigator contact page'
    />
  )

  const optionDescription = isRegionalNetworkCopyEnabled ? (
    <FormattedMessage {...CARELON_REGIONAL_NETWORK_MESSAGES.description} />
  ) : (
    <FormattedMessage
      defaultMessage='You also have access to prescribing providers in Carelon’s network.'
      description='Description for Carelon Behavioral Health provider directory link explaining access to prescribing providers'
    />
  )

  return (
    <CareOptionCard
      onPress={onPress}
      optionIcon={<InPersonStroke size={24} fillColor={colors.textSecondary} />}
      optionHeader={optionHeader}
      optionDescription={optionDescription}
      useExternalLinkIcon={true}
      testId={tID('CareNavigatorCarelonDirectoryOptionCard')}
    />
  )
}
